import React, { useState, useEffect, useRef } from "react";
import "./FichaASA.css";

function FichaASA() {
  const [isRecording, setIsRecording] = useState(false);
  const [status, setStatus] = useState("Pronto");
  const [anamnese, setAnamnese] = useState([]);
  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const fullAudioChunksRef = useRef([]);
  const intervalRef = useRef(null);
  const url = "https://prontuarioapi.sgebot.com.br";

  useEffect(() => {
    const initialAnamnese = [
      {
        pergunta: "Você possui alguma doença crônica (como diabetes, hipertensão, ou insuficiência cardíaca)?",
        resposta: ""
      },
      {
        pergunta: "Você já fez cirurgias anteriormente? Houve complicações?",
        resposta: ""
      },
      {
        pergunta: "Tem alergia a medicamentos, alimentos ou substâncias?",
        resposta: ""
      },
      {
        pergunta: "Faz uso de algum medicamento regularmente?",
        resposta: ""
      },
      {
        pergunta: "Fuma ou consome álcool frequentemente?",
        resposta: ""
      },
      {
        pergunta: "Teve algum problema respiratório (asma, apneia do sono, etc.)?",
        resposta: ""
      },
      {
        pergunta: "Já apresentou reações adversas à anestesia?",
        resposta: ""
      },
      {
        pergunta: "Qual é o seu peso e altura atuais?",
        resposta: ""
      }
    ];
    setAnamnese(initialAnamnese);
  }, []);

  const startRecording = async () => {
    try {
      setStatus("Capturando áudio...");
      setIsRecording(true);
      chunksRef.current = [];
      fullAudioChunksRef.current = [];

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;

      mediaRecorder.ondataavailable = (event) => {
        chunksRef.current.push(event.data);
        fullAudioChunksRef.current.push(event.data);
      };

      mediaRecorder.start(1000); // Request data every second

      // Envia o áudio desde o início até o momento atual a cada 10 segundos
      intervalRef.current = setInterval(() => {
        if (fullAudioChunksRef.current.length > 0) {
          const audioBlob = new Blob(fullAudioChunksRef.current, { type: "audio/ogg; codecs=opus" });
          sendAudioToServer(audioBlob, "partial");
        }
      }, 10000);

    } catch (error) {
      setStatus("Erro ao iniciar a gravação.");
      console.error("Erro ao acessar o microfone:", error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      setStatus("Parando gravação e enviando áudio completo...");
      mediaRecorderRef.current.stop();
      clearInterval(intervalRef.current);

      // Envia o áudio completo
      const audioBlob = new Blob(fullAudioChunksRef.current, { type: "audio/ogg; codecs=opus" });
      fullAudioChunksRef.current = [];
      sendAudioToServer(audioBlob, "full");
      setIsRecording(false);
    }
  };

  const sendAudioToServer = (audioBlob, type) => {
    const formData = new FormData();
    formData.append("audio", audioBlob, `${type}_recording.ogg`);
    formData.append("type", type);

    fetch(url + "/analyse-audio", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setStatus(
          type === "partial"
            ? "Áudio parcial enviado com sucesso!"
            : "Áudio completo enviado com sucesso!"
        );
        console.log(`Resposta do servidor (${type}):`, data);
        const parsedData = JSON.parse(data.retorno_llm);
        if (parsedData.anamnese) {
          setAnamnese(parsedData.anamnese);
        }

      })
      .catch((error) => {
        setStatus("Erro ao enviar áudio.");
        console.error(`Erro ao enviar áudio (${type}):`, error);
      });
  };

  return (
    <div className="container">
      <h1 className="title">Avaliação Pré-Anestésica (ASA)</h1>
      <div className="questions">
        <h2>Perguntas</h2>
        <ul>
          {anamnese.map((item, index) => (
            <li key={index} className="question-item">
              <strong>{item.pergunta}</strong>
              <p
                className={`response ${
                  item.resposta.includes("não respondida ainda") || item.resposta === "" ? "unanswered" : ""
                }`}
              >
                {item.resposta || "não respondida ainda"}
              </p>
            </li>
          ))}
        </ul>
      </div>
      <div className="controls">
        <button
          className={`button ${isRecording ? "disabled" : ""}`}
          onClick={startRecording}
          disabled={isRecording}
        >
          <i className="fas fa-microphone"></i> Iniciar Captura
        </button>
        <button
          className={`button ${!isRecording ? "disabled" : ""}`}
          onClick={stopRecording}
          disabled={!isRecording}
        >
          <i className="fas fa-stop"></i> Parar Captura
        </button>
      </div>
      <div className="status">
        <p>Status: <span>{status}</span></p>
      </div>
    </div>
  );
};

export default FichaASA;
